import { render, staticRenderFns } from "./recording-tip.vue?vue&type=template&id=51834f6c&scoped=true&"
import script from "./recording-tip.vue?vue&type=script&lang=js&"
export * from "./recording-tip.vue?vue&type=script&lang=js&"
import style0 from "./recording-tip.vue?vue&type=style&index=0&id=51834f6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51834f6c",
  null
  
)

export default component.exports